import { decode } from "base-64";
import API_ENDPOINT from "../wm.api.service";
import {
  follow_unfollow,
  like_unlike,
  postMainCommentOnBlog,
  postMainChildCommentOnBlog,
} from "../functions/reactions";
import { MAIN_URL } from "../config";
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const service = urlParams.get("service");
const redirectURL = urlParams.get("metaURL");
const action = urlParams.get("action");
const aData = urlParams.get("aData");
const metaID = urlParams.get("metaID");
const metaPost = urlParams.get("metaPost");
const metaParentID = urlParams.get("metaParentID");
const metaContent = urlParams.get("metaContent");

export const authAction = (encodeToken, localServe = "user") => {
  if (
    decode(service) === "blogs/create-blogs" ||
    decode(service) === "questions/create-question"
  ) {
    return window.location.assign(`${MAIN_URL}${decode(service)}`);
  }
  if (decode(service) === "main") {
    return auth_From_Wisemonkeys(encodeToken);
  }
  if (decode(service) === "landingpage") {
    return window.location.assign(`${API_ENDPOINT.redirectURL}`);
  }
  if (decode(service) === "forms") {
    return auth_From_Forms_WiseMonkeys();
  }
  if (
    decode(service) !== "forms" &&
    !decode(service) !== "main" &&
    !decode(service) !== "landingpage"
  ) {
    return internalRedirectionOnLogin(localServe);
  }
};

// FORM.WISEMONKEYS
const auth_From_Forms_WiseMonkeys = () => {
  window.location.assign(
    `https://${decode(service)}.spiralbound.in${decode(redirectURL)}`
  );
};

// WISEMONKEYS & ME.WISEMONKEYS
const auth_From_Wisemonkeys = (encodeToken) => {
  if (decode(action) === "FOLLOW" || decode(action) === "UNFOLLOW") {
    follow_unfollow(encodeToken, action, aData, redirectURL);
  }
  if (decode(action) === "LIKE" || decode(action) === "UNLIKE") {
    like_unlike(encodeToken, action, metaID, metaPost, redirectURL);
  }
  if (decode(action) === "COMMENT") {
    postMainCommentOnBlog(
      encodeToken,
      action,
      metaID,
      metaPost,
      redirectURL,
      metaContent
    );
  }
  if (decode(action) === "COMMENT_CHILD") {
    postMainChildCommentOnBlog(
      encodeToken,
      action,
      metaID,
      metaPost,
      redirectURL,
      metaContent,
      metaParentID
    );
  }
  if (decode(action) === "USER_PAGE") {
    window.location.assign(
      `${API_ENDPOINT.redirectURL}/${decode(redirectURL)}`
    );
  }
};

// CERTIFICATE.WISEMONKEYS
const auth_From_Certificate_Wisemonkeys = () => {};
const internalRedirectionOnLogin = (slug) => {
  // console.log("sug",decode(slug))
  window.location.assign(`/${slug}`);
};
